export const keyboardListener=(e)=>{
    
    if(!(e.target.matches("input") || e.target.matches("#customScreenKeyboard")))
    {
    closeKeyboard();
    } 
}


export const addKeyboardClickListener=()=>{
    window.document.addEventListener("click",keyboardListener);
}

export const removeKeyboardClickListener=()=>{
    window.document.removeEventListener("click",keyboardListener);
}

export const invokeKeyboard=(timeDelay?:number|null,valueToPost?:string)=>{

    const raiseKeyboard=()=>{
        let keyboardIframe=document.querySelector("iframe");
        keyboardIframe?.contentWindow?.postMessage({
        eventData: {
          language: "en-us",
          theme:"k-sapphire-martini-theme",
          inputValue: valueToPost,
          
      },
      eventType: "KeyboardOpen"
    }, '*');
    addKeyboardClickListener();
    }
    
    if(timeDelay)
    setTimeout(raiseKeyboard,timeDelay);
    else
    raiseKeyboard();
    
}

export const closeKeyboard=()=>{
    let keyboardIframe=document.querySelector("iframe");
        keyboardIframe?.contentWindow?.postMessage({
        eventData: {
          language: "en-us",
          
      },
      eventType: "KeyboardClose"
    }, '*');
    removeKeyboardClickListener();
   
}

export const checkIfKeyboardContainerExists=()=>{
    let keyboardIframe : HTMLIFrameElement = document.querySelector("iframe#customScreenKeyboard");
    let keyboardContainerNode = keyboardIframe?.contentWindow?.document.querySelector(".keyboard-container.lang-fetched");
    if(keyboardContainerNode) return true;
    return false;
}


